import { render, staticRenderFns } from "./CoachTx.vue?vue&type=template&id=6f631818&scoped=true"
import script from "./CoachTx.vue?vue&type=script&lang=js"
export * from "./CoachTx.vue?vue&type=script&lang=js"
import style0 from "./CoachTx.vue?vue&type=style&index=0&id=6f631818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f631818",
  null
  
)

export default component.exports